import styled from 'styled-components'

const EntityMenuContainer = styled.section`
  display: flex;
  flex-direction: column;
`
const EntityButtonContainer = styled.div`
  max-width: calc(100vw - 40px);
  min-width: 100%;
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: center;
  padding: 8px;
  cursor: pointer;
  background-color: var(--neutral-theme);
`
const HeaderSkeletonContainer = styled.div`
  width: 100%;
  color: var(--typography500);
  background-color: var(--neutral-theme);
  padding: 12px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .android-transition {
    &:active {
      transition: 0.4s ease-out;
      background-color: rgba(125, 125, 125, 0.15);
    }
  }
`

const SubTitleContainer = styled.div`
  margin-top: 0.5rem;
  padding: 0.5rem;
`

export { EntityMenuContainer, HeaderSkeletonContainer, EntityButtonContainer, SubTitleContainer }
